<template>
  <div class=" datatableWrapper">
    <div class=" datatableWrapperInner">
      <div class="row">
        <div class="col  col-12 ">
          <div class="col col-sm-12 col-md-6" v-if="options && options.isTextSearch===false">
          </div>
          <div class="col col-sm-12 col-md-6" v-if="(!options) || options.isTextSearch!==false">
            <div class="row form-group">
              <div class="col col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-right Xpl20" style="">
                <label for="select" class=" form-control-label">{{ $t('TableDatatableJs.search') }}</label>
              </div>
              <div class="col col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 input-group Xpl20">


                <table>
                  <tr>
                    <td>

                      <div class="input-group">

              <span :title="$t('TableDatatableJs.titletagmemory')" v-if="!isKeepsettings" class="input-group-addonX btn btn-primary" v-on:click="keepsettingsChange"><i
                class="fa fa-minus"></i> {{ $t('TableDatatableJs.isNotKeepsettings') }} <small class="mem">{{ $t('global.mem')}}</small></span>
                        <span :title="$t('TableDatatableJs.titletagmemory')" v-if="isKeepsettings" class="input-group-addonX btn btn-success" v-on:click="keepsettingsChange"><i
                          class="fa fa-check"></i> {{ $t('TableDatatableJs.isKeepsettings') }} <small class="mem">{{ $t('global.mem')}}</small></span>
                        <InputText style="flex: 1 1 0;" hasToKeyboard="auto" id="text-input" v-model="searchText" title="" placeholder="" dataLayout="t" className="form-control w100i d-block"/>
                        <!--<input v-model="searchText" type="text" id="text-input" name="searchText" placeholder="" class="form-control">-->
                        <span v-on:click="(searchText='')" class="input-group-addon cursor"><i class="fa fa-times"></i></span>

                      </div>
                    </td>
                    &nbsp;
                    <td class="" v-if="searchFieldsFilters && searchFieldsFilters.length>0">
                      <select id="selectSearchField" v-model="selectedSearchField" class="form-control mandatory w100" name="selectSearchField">
                        <!--:disabled="data.wf_status_saved === 'REJECTED' || data.wf_status_saved === 'PAID'"-->
                        <!--:readonly="data.wf_status_saved === 'REJECTED' || data.wf_status_saved === 'PAID'"-->

                        <option value="">{{$t('form.all')}}</option>
                        <option v-for="(searchFieldsFilter ,i) in searchFieldsFilters" :value="searchFieldsFilter.value">{{$t(searchFieldsFilter.text)}}
                        </option>
                      </select>
                    </td>

                  </tr>
                </table>

              </div>
            </div>
          </div>
          <div class="col col-sm-12 col-md-6">
            <div class="row form-group">
              <div class="col col-12 col-sm-2 col-md-4 col-lg-4 col-xl-4 text-right ">
                <label for="text-input" class=" form-control-label">{{ $t('TableDatatableJs.perpage') }}</label>
              </div>
              <div class="col col-12 col-sm-10 col-md-8 col-lg-8 col-xl-8 ">
                <table class="w100">
                  <tr>
                    <td class="w1">
                      <div style="position: relative; top:0; left:0;">

              <span :title="$t('TableDatatableJs.titletagmemory')" v-if="!isKeepsettingsPager" class="input-group-addonX btn btn-primary" v-on:click="keepsettingsPagerChange"><i
                class="fa fa-minus"></i> {{ $t('TableDatatableJs.isNotKeepsettings') }} <small class="mem">{{ $t('global.mem')}}</small></span>
                        <span :title="$t('TableDatatableJs.titletagmemory')" v-if="isKeepsettingsPager" class="input-group-addonX btn btn-success" v-on:click="keepsettingsPagerChange"><i
                          class="fa fa-check"></i> {{ $t('TableDatatableJs.isKeepsettings') }} <small class="mem">{{ $t('global.mem')}}</small></span>
                      </div>

                    </td>
                    <td class="w100">
                      <select id="select" class="form-control" v-model="perPageStr" name="perPageStr">
                        <option value="3">3</option>
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                      </select>

                    </td>
                  </tr>

                </table>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!--<template v-if="selectedRowIds && selectedRowIds.length>0">-->
      <!--<div class="row infoblock mb-2">-->
      <!--<div class="col">-->
      <!--<div class="col-lg-12  pb-2 ">-->
      <!--<div class="pb-1 ">-->
      <!--{{$t(options.operationstitle)}} ({{selectedRowIds.length}} {{$t('TableDatatableJs.countSelectedItems')}}) :<br>-->
      <!--</div>-->
      <!--<div class="pb-1  ">-->
      <!--<template v-if="options && options.operationstitle">-->
      <!--&lt;!&ndash;{{options.operationstitle}}&ndash;&gt;-->
      <!--&lt;!&ndash;{{options.operationfunctions}}&ndash;&gt;-->
      <!--<template v-if="options.operationfunctions && options.operationfunctions.length>0">-->
      <!--<template v-for="(operationfunction, i) in options.operationfunctions">-->

      <!--<template v-if="operationfunction && operationfunction.displaytype && operationfunction.displaytype === 'button'">-->
      <!--<div class="row form-group">-->
      <!--<div class="col-12 text-right">-->
      <!--<button type="button" class="btn btn-primary btn-sm" v-on:click="function g(e){operationfunction.cbfn(e,selectedRowIds)}">-->
      <!--&lt;!&ndash;<i class="fa fa-dot-circle-o"></i>&ndash;&gt;-->
      <!--{{$t(operationfunction.title)}}-->
      <!--</button>-->
      <!--</div>-->
      <!--</div>-->

      <!--</template>-->

      <!--&lt;!&ndash;<template v-if="operationfunction && operationfunction.displaytype && operationfunction.displaytype === 'buttonclosedate'">&ndash;&gt;-->
      <!--&lt;!&ndash;<hr>&ndash;&gt;-->

      <!--&lt;!&ndash;<div class="row form-group">&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="col-12 col-md-3"><label for="dateSelector" class=" form-control-label">{{ $t(operationfunction.dateSelectorTitle) }}&ndash;&gt;-->
      <!--&lt;!&ndash;<span class="validatorrequired">({{ $t('validator.required') }})</span></label>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="col-12 col-md-6">&ndash;&gt;-->
      <!--&lt;!&ndash;<InputText type="DatetimepickerBp"&ndash;&gt;-->
      <!--&lt;!&ndash;id="dateSelector" name="dateSelector" v-model="dateSelector" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""&ndash;&gt;-->
      <!--&lt;!&ndash;:title="$t(operationfunction.dateSelectorTitle)"&ndash;&gt;-->
      <!--&lt;!&ndash;placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('dateSelector')"/>&ndash;&gt;-->
      <!--&lt;!&ndash;<small class="form-text text-muted"></small>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="col-12 col-md-3 text-right">&ndash;&gt;-->
      <!--&lt;!&ndash;<button type="button" class="btn btn-primary btn-sm" v-on:click="function g(e){operationfunction.cbfn(e,selectedRowIds, dateSelector)}">&ndash;&gt;-->
      <!--&lt;!&ndash;&lt;!&ndash;<i class="fa fa-dot-circle-o"></i>&ndash;&gt;&ndash;&gt;-->
      <!--&lt;!&ndash;{{$t(operationfunction.title)}}&ndash;&gt;-->
      <!--&lt;!&ndash;</button>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->

      <!--&lt;!&ndash;</template>&ndash;&gt;-->


      <!--</template>-->
      <!--</template>-->
      <!--</template>-->
      <!--</div>-->

      <!--<div class="row form-group">-->
      <!--<div class="col-12 text-right">-->


      <!--<template v-if="selectedRowIds && selectedRowIds.length>0">-->

      <!--<div v-if="hasXlsField">-->
      <!--<button type="button" class="btn btn-primary btn-sm" v-on:click="exportToXlsSelected">-->
      <!--<i class="fa fa-dot-circle-o"></i>-->
      <!--<template v-if="options && options.exportToXlsKeySelected">-->
      <!--{{$t(options.exportToXlsKeySelected)}}-->
      <!--</template>-->
      <!--<template v-if="!options || !options.exportToXlsKeySelected">-->
      <!--{{$t('global.exportToXlsSelected')}}-->
      <!--</template>-->
      <!--</button>-->
      <!--</div>-->


      <!--</template>-->

      <!--<template v-if="!selectedRowIds || selectedRowIds.length<=0">-->
      <!--<div v-if="hasXlsField">-->
      <!--<button type="button" class="btn btn-primary btn-sm" v-on:click="exportToXls">-->
      <!--<i class="fa fa-dot-circle-o"></i>-->
      <!--<template v-if="options && options.exportToXlsKey">-->
      <!--{{$t(options.exportToXlsKey)}}-->
      <!--</template>-->
      <!--<template v-if="!options || !options.exportToXlsKey">-->
      <!--{{$t('global.exportToXls')}}-->
      <!--</template>-->
      <!--</button>-->
      <!--</div>-->
      <!--</template>-->


      <!--</div>-->
      <!--</div>-->

      <!--&lt;!&ndash;<span class="pb1"></span>&ndash;&gt;-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->


      <!--</template>-->
      <div class="row">
        <div class="col">

          <ul class="col-lg-12 col-xl-5 pl10 pb2 nav_nav-pills" v-if="hasCheckboxes||hasXlsField ||(options && options.operationfunctions && options.operationfunctions.length>0)">

            <li class="pointer nav-item dropdown" v-on:click="setShow" v-bind:class="{show}">
              <span class="nav-linkX btnbtn-primary dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{{ $t('TableDatatableJs.options') }} </span>
            </li>
            <div class="dropdown-menu" v-bind:class="{show}">

              <div v-if="hasCheckboxes">
                <button class="dropdown-item" v-on:click="selectall">{{$t("global.selectall")}}</button>
                <button class="dropdown-item" v-on:click="selectnone">{{$t("global.selectnone")}}</button>
                <div class="dropdown-divider"></div>
              </div>

              <div v-if="hasXlsField">
                <button type="button" class="dropdown-item" v-on:click="function g(e){show = false;exportToXls()}">
                  <template v-if="options && options.exportToXlsKey">
                    {{$t(options.exportToXlsKey)}}
                  </template>
                  <template v-if="!options || !options.exportToXlsKey">
                    {{$t('global.exportToXls')}}
                  </template>
                </button>

                <template v-if="hasCheckboxes">

                  <button type="button" class="dropdown-item" v-on:click="function g(e){show = false;exportToXlsSelected()}">
                    <template v-if="options && options.exportToXlsKeySelected">
                      {{$t(options.exportToXlsKeySelected)}}
                    </template>
                    <template v-if="!options || !options.exportToXlsKeySelected">
                      {{$t('global.exportToXlsSelected')}}
                    </template>
                  </button>
                </template>
                <div class="dropdown-divider"></div>
              </div>


              <div v-if="hasXlsField">
              </div>

              <template v-if="options && options.operationfunctions && options.operationfunctions.length>0">
                <template v-for="(operationfunction, i) in options.operationfunctions">

                  <template v-if="operationfunction && operationfunction.displaytype && operationfunction.displaytype === 'button'">
                    <div class="row form-group">
                      <div class="col-12 ">
                        <button type="button" class="dropdown-item" v-on:click="function g(e){ setShow(); operationfunction.cbfn(e,getSelectedRowIds(operationfunction.key || 'id'))}">
                          <!--<i class="fa fa-dot-circle-o"></i>-->
                          {{$t(operationfunction.title)}}
                        </button>
                      </div>
                    </div>
                  </template>


                </template>
              </template>

              <template v-if="options && options.operationfunctions && options.operationfunctions.length>0">
                <template v-for="(operationfunction, i) in options.operationfunctions">
                  <template v-if="operationfunction && operationfunction.displaytype && operationfunction.displaytype === 'buttonclosedate'">


                    <button class="dropdown-item" v-on:click="function g(e){show = false;showModal(i)}">{{$t("Transferlist.setTransferedAllSelectedDate")}}</button>
                  </template>
                </template>
              </template>
              <!--<div class="dropdown-divider"></div>-->


            </div>

            <!--<li class="nav-item">-->
            <!--<a class="nav-link" href="#">Menu 2</a>-->
            <!--</li>-->
            <!--<li class="nav-item">-->
            <!--<a class="nav-link" href="#">Menu 3</a>-->
            <!--</li>-->
          </ul>


          <template v-if="options && options.operationfunctions && options.operationfunctions.length>0">
            <template v-for="(operationfunction, i) in options.operationfunctions">

              <template v-if="operationfunction && operationfunction.displaytype && operationfunction.displaytype === 'buttonclosedate'">

                <div class="">

                  <div :class="(modalShow)?'modal fade show':'modal fade '" v-bind:style="{'display':(modalShow)?'block':'none'}" id="mediumModal" tabindex="-1" role="dialog" aria-labelledby="mediumModalLabel"
                       aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="mediumModalLabel"></h5>
                          <button type="button" class="close" data-dismiss="modal" :aria-label="$t('close')" v-on:click="fnCancel">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">

                          <div class="row form-group">
                            <div class="col-12 col-md-3"><label for="dateSelector" class=" form-control-label">{{ $t(operationfunction.dateSelectorTitle) }}
                              <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                            </div>
                            <div class="col-12 col-md-5">
                              <InputText type="DatetimepickerBp"
                                         id="dateSelector" name="dateSelector" v-model="dateSelector" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                         :title="$t(operationfunction.dateSelectorTitle)"
                                         placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('dateSelector')"/>
                              <small class="form-text text-muted"></small>
                            </div>
                            <div class="col-12 col-md-3 text-right">
                              <button type="button" class="btn btn-primary btn-sm"
                                      v-on:click="function g(e){setShowModal(); operationfunction.cbfn(e,getSelectedRowIds(operationfunction.key || 'id'), dateSelector)}">
                                <!--<i class="fa fa-dot-circle-o"></i>-->
                                {{$t(operationfunction.title)}}
                              </button>
                            </div>
                          </div>


                          <!--<p>-->
                          <!--{{msgText}}-->
                          <!--<template v-if="tmsgText">-->
                          <!--{{ $t("modal."+tmsgText) }}-->
                          <!--</template>-->
                          <!--</p>-->
                        </div>
                        <div class="modal-footer">
                          <template>
                            <!--v-if="type==='confirm'"-->
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="fnCancel">{{$t('modal.cancel')}}</button>
                            <!--<button type="button" class="btn btn-primary defaultModalButton" v-on:click="fnConfirm">{{$t('modal.ok')}}</button>-->
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="(modalShow)?'modal-backdrop fade show':''" v-on:click="fnCancel"></div>

                </div>


                <!--<hr>-->


              </template>

            </template>
          </template>

        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="col-lg-12 col-xl-5 pl10">
                   <span class="dataTables_info" role="status"
                         aria-live="polite">
            {{$t('TableDatatableJs.countMaxPageText')}}:  {{this.data.length}}
                     <template v-if="data.length>dataFiltered.length">
            {{$t('TableDatatableJs.countDataFilteredText')}}:  {{this.dataFiltered.length}}
                     </template>
            ({{((this.actualPage * this.perPage) - this.perPage)}} - {{(this.actualPage * this.perPage)}})
                    </span>
            <!--<span class="text-left">-->
            <!--<span v-if="!isKeepsettings" class="btn btn-secondary" v-on:click="keepsettingsChange"><i class="fa fa-times"></i> {{ $t('TableDatatableJs.isNotKeepsettings') }}</span>-->
            <!--<span v-if="isKeepsettings" class="btn btn-primary" v-on:click="keepsettingsChange"><i class="fa fa-check"></i> {{ $t('TableDatatableJs.isKeepsettings') }}</span>-->
            <!--</span>-->

          </div>
          <div class="col-lg-12 col-xl-7 ">
            <div class="dataTables_paginate paging_simple_numbers">
              <ul class="pagination">
                <li v-on:click="prev()" class="paginate_button page-item previous "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0"
                                                                                       class="page-link">{{$t('TableDatatableJs.prev')}}</a></li>
                <li v-on:click="setActualPage(actualPage - 500)" v-if="(this.actualPage>500)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="1" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage > 500) ? (this.actualPage - 500) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage - 50)" v-if="(this.actualPage>50)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)" aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="1" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage > 50) ? (this.actualPage - 50) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage - 3)" v-if="(this.actualPage>3)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="1"
                                                                                                                                tabindex="0"
                                                                                                                                class="page-link">{{(this.actualPage > 3) ? (this.actualPage - 3) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage - 2)" v-if="(this.actualPage>2)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="2"
                                                                                                                                tabindex="0"
                                                                                                                                class="page-link">{{(this.actualPage > 2) ? (this.actualPage - 2) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage - 1)" v-if="(this.actualPage>1)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="3"
                                                                                                                                tabindex="0"
                                                                                                                                class="page-link">{{(this.actualPage > 1) ? (this.actualPage - 1) : ""}}</a>
                </li>
                <li v-if="(true)" class="paginate_button page-item active"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="4" tabindex="0"
                                                                              class="page-link">{{this.actualPage}}</a></li>
                <li v-on:click="setActualPage(actualPage + 1)" v-if="((this.actualPage < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="5" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage < this.countMaxPage) ? (this.actualPage + 1) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage + 2)" v-if="((this.actualPage+1 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                      aria-controls="bootstrap-data-table"
                                                                                                                                                      data-dt-idx="6" tabindex="0"
                                                                                                                                                      class="page-link">{{(this.actualPage + 1 < this.countMaxPage) ? (this.actualPage + 2) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage + 3)" v-if="((this.actualPage+2 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                      aria-controls="bootstrap-data-table"
                                                                                                                                                      data-dt-idx="6" tabindex="0"
                                                                                                                                                      class="page-link">{{(this.actualPage + 2 < this.countMaxPage) ? (this.actualPage + 3) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage + 50)" v-if="((this.actualPage+50 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                        aria-controls="bootstrap-data-table"
                                                                                                                                                                        data-dt-idx="6" tabindex="0"
                                                                                                                                                                        class="page-link">{{(this.actualPage + 50 < this.countMaxPage) ? (this.actualPage + 51) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage + 500)" v-if="((this.actualPage+500 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                          aria-controls="bootstrap-data-table"
                                                                                                                                                                          data-dt-idx="6" tabindex="0"
                                                                                                                                                                          class="page-link">{{(this.actualPage + 500 < this.countMaxPage) ? (this.actualPage + 501) : ""}}</a>
                </li>
                <li v-on:click="next()" class="paginate_button page-item next"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0"
                                                                                  class="page-link">{{$t('TableDatatableJs.next')}}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <table class="table table-striped">
          <thead class="makeSticky">
          <tr>
            <th scope="col" v-for="(headRow, index) in headWithFilter" v-on:click="headRowClick(headRow, index)"
                :class="(headRow.cbclassth)?headRow.cbclassth(headRow, index)+' cursor': (headRow.classth)?headRow.classth +' cursor': ' cursor' ">
              <i v-bind:class="{
                            'shorter-icon fa fa-sort-asc':(headRow.sortDirection==='asc'),
                         'shorter-icon fa fa-sort-desc':(headRow.sortDirection==='desc'),
                         'shorter-icon fa fa-sort':(typeof headRow.sortDirection==='undefined')
                        }"></i>
              {{$t(headRow.title)}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(dataRow, index) in dataRange(((this.actualPage*this.perPage)-this.perPage), this.perPage)">
            <!--<tr v-for="(dataRow, index) in dataFiltered">-->

            <td v-for="(headRow, index2) in head" :style="headRow.styletd" :class="(headRow.cbclasstd)?headRow.cbclasstd(dataRow[headRow.key], 'type', dataRow, 'meta'):headRow.classtd">


              <template v-if="headRow.celltype">
                <input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="dataFiltered[(actualPage*perPage)-perPage+index]['TableDatatableJs_selected']" class="checkboxBig w200px"
                       >
                <!--v-on:change="celltypeChkbClick($event,index, headRow, dataRow)"-->
                <!--<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="dataFiltered[(actualPage*perPage)-perPage+index][headRow.key]" class="checkboxBig w200px" v-on:change="chkbClick($event,index, headRow, dataRow)">-->
                <!--:disabled="String(modelRowIsEditing[dataRow.id]) !== '1'"-->
                <!--:readonly="String(modelRowIsEditing[dataRow.id]) !== '1'"-->
              </template>

              <template v-if="headRow.linkurl">
                            <span :style="headRow.styletext" :class="headRow.classtext"><router-link :to="{ path: headRow.linkurl+'/'+dataRow.id}" :class="headRow.linkclass"><i
                              :class="headRow.linkiconclass"></i> {{$t(headRow.linktext)}}</router-link></span>
              </template>


              <template v-if="headRow.displayFn">
                <template v-if="headRow.displayFn && headRow.displayFn(dataRow[headRow.key],'type',dataRow,'meta')">
                            <span :style="headRow.styletext" :class="headRow.classtext"><a href="javascript:void 0;" v-on:click="function g(e){headRow.linkfn(e,dataRow[headRow.key],'type',dataRow,'meta')}"
                                                                                           :class="headRow.linkclass"><i :class="headRow.linkiconclass"></i>
                                {{$t(headRow.linktext)}}</a></span>

                </template>
              </template>

              <template v-if="!headRow.displayFn">
                <template v-if="headRow.linkfn">
                            <span :style="headRow.styletext" :class="headRow.classtext"><a href="javascript:void 0;" v-on:click="function g(e){headRow.linkfn(e,dataRow[headRow.key],'type',dataRow,'meta')}"
                                                                                           :class="headRow.linkclass"><i :class="headRow.linkiconclass"></i>
                                {{$t(headRow.linktext)}}</a></span>
                </template>
              </template>

              <!--<template v-if="headRow.render">-->
              <!--XX{{headRow.render(dataRow[headRow.key], "??type", headRow, "??meta")}}-->
              <!--</template>-->


              <template v-if="headRow.roweditor">
                <!--{{              dataRow.id}}-->
                <!--{{ modelRowIsEditing }}-->
                <template v-if="modelRowIsEditing[dataRow.id]">
                  <button type="button" class="btn btn-primary btn-sm" v-on:click="doSave($event,index, headRow, dataRow)">
                    <i class="fa fa-save"></i> {{$t('global.save')}}
                  </button>
                </template>
                <template v-if="!modelRowIsEditing[dataRow.id]">
                  <button type="button" class="btn btn-primary btn-sm" v-on:click="doEdit($event,index, headRow, dataRow)">
                    <i class="fa fa-edit"></i> {{$t('global.edit')}}
                  </button>
                </template>

              </template>

              <template v-if="headRow.editable && headRow.rowedittype==='datetimepicker'">
                <div class="DatetimepickerBpContainer">
                  <InputText type="DatetimepickerBp"
                             id="dt_transfer" name="headRow.checkboxData.fieldKey" v-model="dataEditing[dataRow[primaryKey]][headRow.key]" v-validate="{date_format:'yyyy-MM-dd', required:false}"
                             hasToKeyboard="auto" value=""
                             :title="$t('Document.dt')"
                             placeholder="..." dataLayout="tn" className="form-control mandatoryX" :hasError="errors.has('headRowcheckboxDatafieldKey[index]')"
                             :disabled="String( (String(modelRowIsEditing[dataRow.id]) !== '1'))"
                             :readonly="String( (String(modelRowIsEditing[dataRow.id]) !== '1'))"
                  />
                </div>
              </template>
              <template v-if="headRow.editable && headRow.rowedittype==='checkbox'">
                <input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="dataEditing[dataRow[primaryKey]][headRow.key]" class="checkboxBig w200px"
                       v-on:change="chkbClick($event,index, headRow, dataRow)"
                       :disabled="String(modelRowIsEditing[dataRow.id]) !== '1'"
                       :readonly="String(modelRowIsEditing[dataRow.id]) !== '1'"
                >
              </template>

              <template v-if="!headRow.linkfn&&!headRow.linkurl&&!headRow.editable&&!headRow.roweditor && !headRow.celltype">
                <template v-if="!headRow.render">
                  <template v-if="!headRow.i18Key">
                    <span :style="headRow.styletext" :class="headRow.classtext">{{dataRow[headRow.key]}}</span>
                  </template>
                  <template v-if="headRow.i18Key">
                    <span :style="headRow.styletext" :class="headRow.classtext">{{$t(headRow.i18Key + "." + dataRow[headRow.key]) }}</span>
                  </template>
                </template>
                <template v-if="headRow.render">
                  <template>
                    <span :style="headRow.styletext" :class="headRow.classtext">{{headRow.render(dataRow[headRow.key], "type", dataRow, "meta")}}</span>
                  </template>

                </template>

              </template>
              <template v-if="headRow.addcopytoclipboardbutton">
                <button type="submit" class="btn btn-success btn-sm" v-on:click="btnCopyToClibboard(dataRow[headRow.key])">
                  <i class="fa fa-save"></i> {{$t('TableDatatableJs.copytoclipboard')}}
                </button>
              </template>


            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col">
        <div class="col-lg-12 col-xl-5">
          <div class="dataTables_info" role="status"
               aria-live="polite">{{$t('TableDatatableJs.countMaxPageText')}}:  {{this.data.length}} ({{((this.actualPage * this.perPage) - this.perPage)}} - {{(this.actualPage * this.perPage)}})
          </div>
        </div>
        <div class="col-lg-12 col-xl-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li v-on:click="prev()" class="paginate_button page-item previous "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0"
                                                                                     class="page-link">{{$t('TableDatatableJs.prev')}}</a></li>
              <li v-on:click="setActualPage(actualPage - 500)" v-if="(this.actualPage>500)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                  aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="1" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage > 500) ? (this.actualPage - 500) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 50)" v-if="(this.actualPage>50)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)" aria-controls="bootstrap-data-table"
                                                                                                                                                data-dt-idx="1" tabindex="0"
                                                                                                                                                class="page-link">{{(this.actualPage > 50) ? (this.actualPage - 50) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 3)" v-if="(this.actualPage>3)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="1"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 3) ? (this.actualPage - 3) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 2)" v-if="(this.actualPage>2)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="2"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 2) ? (this.actualPage - 2) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 1)" v-if="(this.actualPage>1)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="3"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 1) ? (this.actualPage - 1) : ""}}</a>
              </li>
              <li v-if="(true)" class="paginate_button page-item active"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="4" tabindex="0"
                                                                            class="page-link">{{this.actualPage}}</a></li>
              <li v-on:click="setActualPage(actualPage + 1)" v-if="((this.actualPage < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                  aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="5" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage < this.countMaxPage) ? (this.actualPage + 1) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 2)" v-if="((this.actualPage+1 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="6" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage + 1 < this.countMaxPage) ? (this.actualPage + 2) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 3)" v-if="((this.actualPage+2 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="6" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage + 2 < this.countMaxPage) ? (this.actualPage + 3) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 50)" v-if="((this.actualPage+50 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                      aria-controls="bootstrap-data-table"
                                                                                                                                                                      data-dt-idx="6" tabindex="0"
                                                                                                                                                                      class="page-link">{{(this.actualPage + 50 < this.countMaxPage) ? (this.actualPage + 51) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 500)" v-if="((this.actualPage+500 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                        aria-controls="bootstrap-data-table"
                                                                                                                                                                        data-dt-idx="6" tabindex="0"
                                                                                                                                                                        class="page-link">{{(this.actualPage + 500 < this.countMaxPage) ? (this.actualPage + 501) : ""}}</a>
              </li>
              <li v-on:click="next()" class="paginate_button page-item next"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0"
                                                                                class="page-link">{{$t('TableDatatableJs.next')}}</a></li>
            </ul>
          </div>
        </div>
      </div>

      <!--<div>-->
      <!--<div v-if="hasXlsField">-->
      <!--<button type="button" class="btn btn-primary btn-sm" v-on:click="exportToXls">-->
      <!--<i class="fa fa-dot-circle-o"></i>-->
      <!--<template v-if="options && options.exportToXlsKey">-->
      <!--{{$t(options.exportToXlsKey)}}-->
      <!--</template>-->
      <!--<template v-if="!options || !options.exportToXlsKey">-->
      <!--{{$t('global.exportToXls')}}-->
      <!--</template>-->
      <!--</button>-->
      <!--</div>-->
      <!--</div>-->


    </div>
  </div>
</template>
<script>
  import InputText from '@/components/InputText.vue';
  import hash from "object-hash";
  import XLSX from 'xlsx';
  import OSheetManager from '@/helper/oSheetManager';
  import oCell from '@/helper/oCell';
  import moment from 'moment';
  import {set, get} from 'lodash';
  import Helper from "../helper/Helper";

  /**
   * The data and head Arrays are more or less same as jquery datatable params
   *
   * Here is an example. It uses link, and i18 translate too
   *
   data: [{"id": "1", "user_name": "value"}, {"id": "2", "user_name": "value2"}],
   head: [
   {
     title: "users.dttitle" ,
     data: "id",
     link: true,
     linkurl: "useredit",
     linkiconclass: "menu-icon fa fa-edit",
     linktext: "users.linktext",
   },
   {
     key: "user_name",
     title: "Title"
   }
   ,{
      key: "user_role",
      title: "Jogkör",
      i18Key:"user_role"
    }
   ]
   *
   */
  export default {
    name: 'TableDatatableJs',
    props: {
      data: Array, // Array of object - Key, value pair
      options: Object, // object - Key, value pair {exportToXlsKey: .. } Possible key: exportToXlsKey
      head: Array, // Array of object - Key, value contains head property
    },
    data(){
      return {
        Helper: Helper,
        show: false,
        modalShow: false,
        hasCheckboxes: false,
        modelRow: {},
        headRowcheckboxDatafieldKey: [],
        modelRowIsEditing: {},
        set: set,
        get: get,
        key: 0,
        sortDirection: void 0,
        isKeepsettings: false,
        isKeepsettingsPager: false,
        searchText: "",
        perPage: 500,
        perPageStr: "500",
        actualPage: 1,
        countMaxPage: 0,
        dataFiltered: [],
        headWithFilter: [],
//        selectedRowIds: [],
        headHash: "",
        hasXlsField: false
        , dateSelector: ""
        , primaryKey: "id" // id
        , dataEditing: {} // id
        ,selectedSearchField: ""
        ,searchFieldsFilters: []
      }
    },
    mounted() {
      const modul = this;
      modul.headHash = hash(modul.head);
      modul.headWithFilter = modul.head;
      modul.searchFieldsFilters = modul.makeSearchFieldsFilters( modul.head );
      modul.headWithFilter.forEach(function(e){
          if(e.sortDirection){
            modul.sortDirection = e.sortDirection;
            modul.key = e.key;
          }
      });
      modul.dataFiltered = modul.data;

    },
    watch: {
      headHash: function (newdata, olddata) {
        const modul = this;
        Array.prototype.forEach.call(modul.headWithFilter, function (e2, i2) {
          if (e2['xlsfield']) {
            modul.hasXlsField = true;
          }
        });
      },
      headWithFilter: function (newdata, olddata) {
        const modul = this;
        Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
          if (e && e.celltype && e.celltype === "mark") {
            modul.primaryKey = e.key;
            modul.hasCheckboxes = true;
          }
        });
        modul.setDataEditing();
      },
      head: function (newdata, olddata) {
        const modul = this;
        modul.headWithFilter = newdata;
      },
      options: function (newdata, olddata) {
        const modul = this;
      },
      data: function (newdata, olddata) {
        const modul = this;
//        modul.dataFiltered = newdata;
        modul.dataFiltered = modul.filterData(modul.searchText);
//        modul.selectedRowIds = [];
          modul.sortDataFiltered();
      },
      modelRow: function (newdata, olddata) {
        const modul = this;
//        modul.dataFiltered = modul.filterData(modul.searchText);
      },
      countMaxPage: function (newdata, olddata) {
        const modul = this;
        if (newdata !== olddata) {
//          console.log("-------------------------új mennyiség--------------")
        }
      },
      selectedSearchField: function (newdata, olddata) {
        const modul = this;
        console.log("selectedSearchField");
        if (modul.searchText.length > 0) {
          const data = modul.filterData(modul.searchText, newdata);
          modul.dataFiltered = data;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SelectedSearchField", newdata);
        } else {
          modul.dataFiltered = modul.deepArrayOfObjCopy(modul.data);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SelectedSearchField", "");
        }
      },
      searchText: function (newdata, olddata) {
        const modul = this;
        console.log("dataFiltered");
        if (modul.searchText.length > 0) {
          const data = modul.filterData(newdata, modul.selectedSearchField);
          modul.dataFiltered = data;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", newdata);
        } else {
          modul.dataFiltered = modul.deepArrayOfObjCopy(modul.data);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", "");
        }
      },
      dataFiltered: function (newdata, olddata) {
          console.log("searchText");
        const modul = this;
        if (newdata !== olddata) {
          this.calculateCountPage();
        }
        if (this.actualPage > this.countMaxPage) {
          if (this.countMaxPage === 0) {
            this.actualPage = 1;
          } else {
            this.actualPage = this.countMaxPage;
          }
        }
        modul.loadDefaultData();
        modul.setDataEditing();
      }
      , perPageStr: function (newdata, olddata) {
        const modul = this;
        this.perPage = Number(this.perPageStr);
      }
      , perPage: function (newdata, olddata) {
        const modul = this;
        this.calculateCountPage();
        if (this.actualPage >= this.countMaxPage) {
          this.actualPage = this.countMaxPage;
        }
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", newdata)
      }
    },
    methods: {
      deepArrayOfObjCopy: function (arr) {
        const retArr = [];
        Array.prototype.forEach.call(arr, function (e) {
          retArr.push(Object.assign({}, e));
        });
        return retArr;
      },
      makeSearchFieldsFilters: function (head) {
        const searchFieldsFilters = [];
        Array.prototype.forEach.call(head, function (e) {
          if (e.searchField) {
            searchFieldsFilters.push({
              value: e.key,
              text: e.title
            });
          }
        });
        return searchFieldsFilters;
      },
      getSelectedRowIds: function (id) {
        const modul = this;
        const selectedRowIds = [];
        const dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        Array.prototype.forEach.call(dataFiltered, function (e) {
          if (e['TableDatatableJs_selected'] === 1) {
            selectedRowIds.push(e[id]);
          }
        });
        return selectedRowIds;
      },
      doSave: function (e, index, headRow, dataRow) {
        const modul = this;
        this.$nextTick(() => {
          headRow.cbSave(e, index, headRow, dataRow).then(function (result) {
            modul.modelRowIsEditing[dataRow.id] = 0;
            modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
          }, function (result) {
            modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
          })
        });
      },
      doEdit: function (e, index, headRow, dataRow) {
        const modul = this;
        this.$nextTick(() => {
          modul.modelRowIsEditing[dataRow.id] = 1
          modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        });
      },
      selectall: function (e) {
        console.log("selectall");
        const modul = this;
        this.$nextTick(() => {
          let key = "id";
          Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
            if (e && e.celltype && e.celltype === "mark") {
              key = e.key;
            }
          });
//          const selectedRowIds = [];
          Array.prototype.forEach.call(modul.dataFiltered, function (e, x) {
            e.TableDatatableJs_selected = 1;
//            const id = e[key];
//            selectedRowIds.push(id);
          });
//          modul.selectedRowIds = selectedRowIds;
          modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        });
        modul.setShow();
      },
      selectnone: function (e) {
        console.log("selectnone");
        const modul = this;
        this.$nextTick(() => {
          Array.prototype.forEach.call(modul.dataFiltered, function (e, i) {
            e.TableDatatableJs_selected = 0;
//            modul.modelRowIsEditing[e.id] = 0;
          });
//          modul.selectedRowIds = [];
          modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        });
        modul.setShow();
      },
      chkbClick: function (e, index, headRow, dataRow) {
        const modul = this;
        this.$nextTick(() => {
          console.log("chkbClick data: ", e, index, headRow, dataRow);

          if (typeof headRow.chkbClick === "function") {
            headRow.chkbClick(e, index, headRow, dataRow, rowActualState)
            modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
          }
        })
      },
      exportToXlsSelected(options){
        const modul = this;
        modul.exportToXls({justSelected: true,})
      },
      exportToXls(options){
        const modul = this;
        const workbook = XLSX.utils.book_new();
        const sheetManager = new OSheetManager();
        let dataSorted = [];

        let dataRows = modul.deepArrayOfObjCopy(modul.dataFiltered);
        if (options && options.justSelected) {
          const elements = [];
          Array.prototype.forEach.call(modul.dataFiltered, function (e, i) {
            if (e.TableDatatableJs_selected === 1) {
              elements.push(e);
            }
          });
          dataRows = elements;
        }

        if (modul.options && modul.options.exportToXlsDefaultSortKey && modul.options.exportToXlsDefaultSortDirection) {
          // if set fix sorting in the options
          const sortKey = modul.options.exportToXlsDefaultSortKey;
          const sortConvertType = modul.options.exportToXlsDefaultSortConvertType;
          const sortType = modul.options.exportToXlsDefaultSortDirection;
          dataSorted = modul.dataSort(dataRows, sortKey, sortType, sortConvertType);
        } else {
          let sortKey = void 0;
          let sortType = void 0;
          let sortConvertType = void 0;

          Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
            if (modul.headWithFilter[i]['sortDirection'] !== void 0) {
              sortKey = e['key'];
              sortType = e['sortDirection'];
              sortConvertType = e['sortConvertType'];
            }
          });
          let dataFiltered = [];
          dataFiltered = Array.from(dataRows);
          if (sortKey !== void 0 && sortType !== void 0) {
            // if we have some actual sorting
            dataSorted = modul.dataSort(dataFiltered, sortKey, sortType, sortConvertType);
          } else {
            // if we don't have some actual sorting
            dataSorted = dataFiltered;
          }
        }


        const sheetName = sheetManager.getSheetNames()[0];
        let actualSheet = sheetManager.getSheetByName(sheetName); // getSheetByName(year);

        let index = 0;
        Array.prototype.forEach.call(modul.headWithFilter, function (headRow, i2) {
          if (headRow['xlsfield']) {
            index++;
            const val = modul.$t(headRow.title);
            actualSheet["" + sheetManager.getColumnNameByNumber(index) + Number(1)] = new oCell().setValue(val).val;
          }
        });

        Array.prototype.forEach.call(dataSorted, function (e, i) {
          let index = 0;
          Array.prototype.forEach.call(modul.headWithFilter, function (e2, i2) {
            let val = void 0;
            if (e2['xlsfield']) {
              index++;
              if (e2['link']) {
                val = (e[e2['data']] === null) ? "" : e[e2['data']];
              } else if (e2['render'] && typeof e2['render'] === "function" && e2['renderxls']) { // renderxls is a function to use the excel export
                let valrendered = e2['renderxls'](e[e2['key']], "type", e, "meta");
                if (e2['xlsfieldNumber']) {
                  try {
                    val = Number(valrendered);
                  } catch (e) {
                    val = "";
                  }
                } else {
                  val = valrendered;
                }
//              val= (e[e2['key']] === null) ? "" : e[e2['key']];
              } else if (e2['render'] && typeof e2['render'] === "function" && e2['xlsrender']) { // xlsrender is a bool, that mark, the xls rendering use the normal render function
                let valrendered = e2['render'](e[e2['key']], "type", e, "meta");
                if (e2['xlsfieldNumber']) {
                  try {
                    val = Number(valrendered);
                  } catch (e) {
                    val = "";
                  }
                } else {
                  val = valrendered;
                }
//              val= (e[e2['key']] === null) ? "" : e[e2['key']];
              } else if (e2['key'] && e2['i18Key']) {
                val = (e[e2['key']] === null) ? "" : modul.$t(e2['i18Key'] + "." + e[e2['key']]);
              } else if (e2['key']) {

                const valx = (e[e2['key']] === null) ? "" : e[e2['key']];
                if (e2['xlsfieldNumber']) {
                  try {
                    val = Number(valx);
                  } catch (e) {
                    val = "";
                  }
                } else {
                  val = valx;
                }


              }
              actualSheet["" + sheetManager.getColumnNameByNumber(index) + Number(i + 2)] = new oCell().setValue(val).val;
            }

          });
        });

//        console.log(actualSheet);
        workbook.Sheets = sheetManager.getSheets();
        const newSheetNames = [];
        newSheetNames.push(sheetName);
        workbook.SheetNames = newSheetNames;
        let filename = "export_data";
        XLSX.writeFile(workbook, filename + ".xlsx");

      },
      filterData(searchText, selectedSearchField){
        const modul = this;
        let data = [];
        const searchIndexes = [];
        const searchIndexei18Keys = [];
        for (let x in modul.headWithFilter) {
          if (!modul.headWithFilter.hasOwnProperty(x)) {
            continue;
          }
          if (modul.headWithFilter[x] && modul.headWithFilter[x].searchField) {
            searchIndexes.push(modul.headWithFilter[x].key);
            searchIndexei18Keys.push(modul.headWithFilter[x].i18Key);
          }
        }

        const getRowIdForSelectedSearchField = function(searchFieldsFilters, selectedSearchField_2) {
          let retId = null;
          Array.prototype.forEach.call(searchFieldsFilters, function (e, i) {
            if (e.key === selectedSearchField_2) {
              retId = i;
            }
          });
          return retId;
        };

        Array.prototype.forEach.call(modul.data, function (e, i) {
          let vanbenne = false;
          let rownum = 0;
          for (let i2 in modul.data[i]) {
            if (!modul.data[i].hasOwnProperty(i2)) {
              continue;
            }
            console.log( selectedSearchField, i2);
            if(selectedSearchField && selectedSearchField !== i2){
              console.log("jaaa");
              continue;
            }

            rownum++;
            if (searchIndexes.length > 0) {
              if (searchIndexes.includes(i2)) {
                if (modul.data[i][i2] && modul.data[i][i2].toLowerCase && modul.data[i][i2].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                  vanbenne = true;
                }
                // i18Key search handling
                const i18Key = searchIndexei18Keys[searchIndexes.indexOf(i2)];
                if (i18Key) {
                  const i18data = modul.$t(i18Key + "." + modul.data[i][i2]);
                  if (modul.data[i][i2] && modul.data[i][i2].toLowerCase && i18data.toLowerCase && i18data.toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                    vanbenne = true;
                  }
                }
              }
            } else { // ha nincs megadva, melyik fieldben keressen -- TODO - a search param vizsgálat itt miért is van?
              if (modul.data[i][i2] && modul.data[i][i2].toLowerCase && modul.data[i][i2].search && modul.data[i][i2] && modul.data[i][i2].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                vanbenne = true;
              }
              // i18Key search handling
              const i18Key = searchIndexei18Keys[searchIndexes.indexOf(i2)];
              if (i18Key) {
                const i18data = modul.$t(i18Key + "." + modul.data[i][i2]);
                if (modul.data[i][i2] && modul.data[i][i2].toLowerCase && modul.data[i][i2].search && i18data.toLowerCase && i18data.toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                  vanbenne = true;
                }
              }
            }
          }
          if (vanbenne === true) {
            data.push(modul.data[i])
          }
        });
        return data;
      },
      keepsettingsChange(){
        const modul = this;
        if (modul.isKeepsettings === true) {
          modul.isKeepsettings = false;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "IsKeepsettings", false);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SelectedSearchField", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", modul.perPageStr);
        } else {
          modul.isKeepsettings = true;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "IsKeepsettings", true);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", modul.actualPage);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", modul.key);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", modul.sortDirection);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", modul.searchText);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SelectedSearchField", modul.selectedSearchField);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", modul.perPageStr);
        }
      },
      keepsettingsPagerChange(){
        const modul = this;
        if (modul.isKeepsettingsPager === true) {
          modul.isKeepsettingsPager = false;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "IsKeepsettingsPager", false);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", "");
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", "");
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", "");
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", modul.perPageStr);
        } else {
          modul.isKeepsettingsPager = true;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "IsKeepsettingsPager", true);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", modul.actualPage);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", modul.key);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", modul.sortDirection);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", modul.searchText);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", modul.perPageStr);
        }
      },
      loadDefaultData(e){
        const modul = this;
        if (localStorage) {
          const isKeepsettingsPager = (localStorage.getItem("TableDatatableJs_" + modul.headHash + "IsKeepsettingsPager") === "true");
          modul.isKeepsettingsPager = isKeepsettingsPager;
          if (isKeepsettingsPager) {
            let perPage = localStorage.getItem("TableDatatableJs_" + modul.headHash + "perPage");
            if (perPage !== void 0 && perPage !== null && Number(perPage) !== "NaN" && Number(perPage) >= 0) {
              modul.perPageStr = String(perPage);
            }
            modul.actualPage = 1;
          }

          const isKeepsettings = (localStorage.getItem("TableDatatableJs_" + modul.headHash + "IsKeepsettings") === "true");
          modul.isKeepsettings = isKeepsettings;
          if (isKeepsettings) {
            const searchText = localStorage.getItem("TableDatatableJs_" + modul.headHash + "SearchText");
            if (searchText !== void 0 && searchText !== null) {
              modul.searchText = searchText;
            }
            const selectedSearchField = localStorage.getItem("TableDatatableJs_" + modul.headHash + "SelectedSearchField");
            if (selectedSearchField !== void 0 && selectedSearchField !== null) {
              modul.selectedSearchField = selectedSearchField;
            }
            let actualPage = localStorage.getItem("TableDatatableJs_" + modul.headHash + "ActualPage");
            if (actualPage !== void 0 && actualPage !== null && Number(actualPage) !== "NaN" && Number(actualPage) >= 0) {
              if (Number(actualPage) <= this.countMaxPage && Number(actualPage) > 0) {
                modul.actualPage = Number(actualPage);
              } else {
                this.actualPage = 1;
              }
            }
            let key = localStorage.getItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key");
            let sortDirection = localStorage.getItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection");
            if (key !== void 0 && key !== null && Number(key) !== "NaN" && Number(key) >= 0 && sortDirection !== void 0 && sortDirection !== null) {
              Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
                modul.$set(modul.headWithFilter[i], ['sortDirection'], void 0)
              });
              if (sortDirection !== "") {
                modul.$set(modul.headWithFilter[Number(key)], ['sortDirection'], sortDirection);
              }
            }
          }

        }
      },
      calculateCountPage(e){
        this.countMaxPage = Math.ceil(this.dataFiltered.length / this.perPage);
      },
      dataSort(arrayData, sortKey, sortType, sortConvertType){
        const modul = this;
        console.log("dataSort")
        return arrayData.sort(function (a, b) {
          let keyA;
          let keyB;
          if (sortConvertType && sortConvertType === "number") {
            keyA = modul.Helper.Number(a[sortKey]);
            keyB = modul.Helper.Number(b[sortKey]);
          } else if (sortConvertType && sortConvertType === "lowercase") {
            keyA = modul.Helper.String(a[sortKey]).toLowerCase();
            keyB = modul.Helper.String(b[sortKey]).toLowerCase();
          } else {
            keyA = a[sortKey];
            keyB = b[sortKey];
          }
          if (keyA === null) {
            keyA = "";
          }
          if (keyB === null) {
            keyB = "";
          }
          if (keyA === void 0) {
            keyA = "";
          }
          if (keyB === void 0) {
            keyB = "";
          }

          if (keyA !== void 0 || keyB !== void 0) {
            console.log("jupp")
          }
          if (sortType === "asc") {
            if (keyA === keyB) return 1;
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
          } else if (sortType === "desc") {
            if (keyA === keyB) return 1;
            if (keyA < keyB) return 1;
            if (keyA > keyB) return -1;
          }
          return 0;
        });
      },
      // csak szeletet ad vissza a dataFiltered-ből.
      dataRange(from, count){
        const modul = this;
        let ret = [];
        // not needed the sort, after the dataFiltered contains the sorted data
        let dataFiltered = [];
        dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        for (let i = from; i < from + count; i++) {
          if (dataFiltered.hasOwnProperty(i) && typeof dataFiltered[i] !== "undefined") {
            ret.push(dataFiltered[i])
            // set the modelRow for possible edit
//            if (!modul.modelRow[dataFiltered[i].id]) {
            modul.modelRow[dataFiltered[i].id] = dataFiltered[i];
//            }
          }
        }
        modul.setDataEditing();
        return ret;
      },
      prev(){
        const modul = this;
        if (this.actualPage > 1) {
          this.actualPage--;
        }
        modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", this.actualPage)
      },
      next(){
        const modul = this;
        if (this.actualPage < this.countMaxPage) {
          this.actualPage++;
        }
        modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", this.actualPage)
      },
      setActualPage(i){
        const modul = this;
        this.actualPage = i;
        modul.dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", i)
      },
      headRowClick(row, key){
        const modul = this;
        Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
          if (Number(key) !== Number(i)) {
            modul.$set(modul.headWithFilter[i], ['sortDirection'], void 0)
          }
        });
        let sortDirection = void 0;
        if (typeof modul.headWithFilter[key]['sortDirection'] === "undefined") {
          modul.$set(modul.headWithFilter[key], ['sortDirection'], "asc");
          sortDirection = "asc";
        } else if (modul.headWithFilter[key]['sortDirection'] === "asc") {
          modul.$set(modul.headWithFilter[key], ['sortDirection'], "desc");
          sortDirection = "desc";
        } else {
          modul.$set(modul.headWithFilter[key], ['sortDirection'], void 0);
          sortDirection = void 0;
        }
        modul.key = key;
        modul.sortDirection = sortDirection;
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", key);
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", sortDirection);
        // need to make the sorting in the module.dataFiltered too for checkboxes in table re-render
        modul.sortDataFiltered();
      },
      sortDataFiltered: function () {
        const modul = this;
        let sortKey = void 0;
        let sortType = void 0;
        let sortConvertType = void 0;
        Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
          if (modul.headWithFilter[i]['sortDirection'] !== void 0) {
            sortKey = e['key'];
            sortType = e['sortDirection'];
            sortConvertType = e['sortConvertType'];
          }
        });
        const dataFiltered = modul.deepArrayOfObjCopy(modul.dataFiltered);
        if (sortKey !== void 0 && sortType !== void 0) {
          modul.dataFiltered = modul.dataSort(dataFiltered, sortKey, sortType, sortConvertType);
        }
      },
      btnCopyToClibboard: function (value) {
        const modul = this;
        let text = value;
        const copyText = document.createElement("input");
        const body = document.getElementsByTagNameNS("*", "body")[0];
        body.append(copyText);
        copyText.value = text;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        copyText.remove();
        const alertId = Math.random();
        modul.$eventBus.$emit('globalAlert', {
          id_delete: alertId,
          type: "success",
          msgPreInner: "",
          msg: "form.succes",
          msgPostInner: "",
          delay: 5000
        });
      },
      setShow(e){
        const modul = this;
        if (modul.show !== "show") {
          modul.show = "show";
        } else {
          modul.show = "";
        }
        return e;
      },
      showModal(e){
        const modul = this;
        modul.setShowModal()
      },
      setShowModal(e){
        const modul = this;
        if (modul.modalShow !== "show") {
          modul.modalShow = "show";
        } else {
          modul.modalShow = "";
        }
        return e;
      },
      fnCancel: function () {
        const modul = this;
        modul.show = false
        modul.modalShow = false
      },
      fnConfirm: function () {
        const modul = this;
        modul.show = false
        modul.modalShow = false
      },
      setDataEditing: function () {
        const modul = this;
        Array.prototype.forEach.call(modul.dataFiltered, function (e, i) {
          const pk = e[modul.primaryKey];
          modul.dataEditing[pk] = e;
        });
      }
    }
    , components: {
      InputText,
    },
  };
</script>

<style scoped>
  .DatetimepickerBpContainer {
    min-width: 200px;
  }

  .colx {
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .pagination {
    float: right
  }

  .pagination-extra > .page-link {
    background-color: rgba(0, 0, 0, .05);
  }

  .pl10 {
    padding-left: 20px !important;
  }

  .pl20 {
    padding-left: 20px !important;
  }

  /*.datatableWrapper{*/
  /*position: relative;*/
  /*top: 0;*/
  /*left: 0;*/
  /*}*/
  /*.datatableWrapperInner{*/
  /*overflow-x: scroll;*/
  /*width: 100%;*/
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
  /*margin: 20px;*/
  /*}*/
  .datatableWrapper .table thead th {
    vertical-align: top;
    position: relative;
    top: 0;
    left: 0;
  }

  .datatableWrapper .table thead th .shorter-icon {
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 16px;*/
  }

  .datatableWrapper .shorter-icon {
    position: absolute;
    left: 2px;
    top: 16px;
  }

  .mem {
    position: absolute;
    left: 1px;
    top: 21px;
  }

  .pointer {
    cursor: pointer;
  }
  .makeSticky {
    position: sticky;
    top: 0;
    background-color: rgba(255,255,255,0.8);
  }

</style>
